import styles from './MachineConnectionsGraph.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { ResponsiveLine } from "@nivo/line";
import moment from 'moment';
import Loader from '../../../miscellaneous/Loader/Loader';

const MachineConnectionsGraph = ({ dateRange }) => {
    const { startDate, endDate } = dateRange;
    const [ tick, setTick ] = useState('day')
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            if(res) {
                setTick(res.tick)
                const dataForChart = res.data.map((group) => {
                    return {
                        id: group.id,
                        color: group.id === 'all' ? '#93d5ed' : '#e1dafe',
                        pointColor: '#5c9ceb',
                        data: group.data,
                    }
                });
                // console.log(dataForChart)
                setData(dataForChart)
            }
           
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        if (data !== null) {
            setIsLoaded(true)
        }
    }, [ data ])


    const getData = async () => {
        try {
            const data = await api.get(`dashboard/activity/graph/machines?startDate=${startDate}&endDate=${endDate}`)
            return data.data.data;
        } catch (e) {
            console.error(e)
        }
    }

    return (<div style={ { width: '100%', height: 300, maxHeight: 340 } } className="d-flex">
        { isLoaded ? <ResponsiveLine
            data={ data }
            tooltip={ point => {
                const groupId = point.point.serieId;
                const date = new Date(point.point.data.x);
                const sessions = point.point.data.y;
                const formattedDate = moment(date).format(tick === 'day' ? "MMM DD" : "MMM Y");
                const groupString = groupId === 'all' ? 'All' : 'Alma';
                return <div style={ {
                    background: '#fff',
                    padding: '10px',
                    borderRadius: '5px',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                } }>{ formattedDate } - { sessions } Connections ({ groupString })</div>;
            } }
            margin={ { top: 30, right: 20, bottom: 45, left: 20 } }
            indexBy="date"
            // pointColor={ [
            //     '#5c9ceb',
            //     '#341f97'
            // ] }
            pointColor={(n) => {
                return n.pointColor
            }}
            lineWidth={ 3 }
            pointBorderColor={ { from: 'serieColor' } }
            enableGridX={ false }
            enableGridY={ false }
            colors={ [
                '#93d5ed',
                '#e1dafe'
            ] }
            curve="monotoneX"
            useMesh={ true }
            enablePointLabel={ true }
            pointLabel="y"
            // pointLabel={ (point) => {
            //     const 
            //     console.log(point)
            //     return 'hey'
            // }}
            pointLabelYOffset={-12}
            enableSlices={false}
            crosshairType="cross"
            xScale={ {
                type: 'time',
                format: "%Y-%m-%d",
                precision: 'day',
                useUTC: false,
                stacked: true,
            } }
            yScale={{
                type: 'linear',
                min: 'auto',
                //max: 'auto',
                //stacked: true,
                reverse: false,
                nice: true,
                

            }}
            axisBottom={ {
                tickValues: tick === 'day' ? 'every 3 days' : 'every 1 month',
                format: tick === 'day' ? "%b %d" : "%b %Y",
                tickRotation: -45,
                legend: '',
                legendOffset: 40,
                legendPosition: 'middle',
                stacked: true,
            } }
            axisLeft={ false }
            enableArea={ true }
        /> : <div style={ { margin: 'auto' } }><Loader color="#ddd"></Loader></div> }
    </div>)
}


export default MachineConnectionsGraph;